<div class="text-bold mb-3" i18n>Draw it in</div>
<div class="drawer-wrapper">
  <i class="far fa-undo cursor-pointer btn-undo" (click)="reset()"></i>
  <canvas #signatureCanvas [style.width.px]="editorSize.width" [style.height.px]="editorSize.height"></canvas>
  <div class="baseline"><i class="fas fa-times"></i></div>
</div>
